<!-- F O O T E R  -->

<section id="footer" class="py-4">
		<div class="container">
			<div class="row">
				<div class="col-md-3">
					<a routerLink="/">
						<img id="footerLogo" class="img-fluid" src="assets/img/logos/footerlogo.png"
							alt="Westwood Insurance logo">
					</a>
					<!-- <img id="footerLogoOne" class="img-fluid pt-5 d-none d-md-block"
						src="assets/img/logos/70-logo-silver-large-font-3-300.png" alt="Westwood Insurance logo"
						style="width: 68%;padding-left: 1.5rem;"> -->
	<!-- commented below as part of WSTW-6205 -->
					<!-- <img id="footerLogoOne" class="img-fluid pt-5 d-none d-md-block"
						src="assets/img/logos/70-logo-silver-large-font-gradient.svg" alt="Westwood Insurance Logo"> -->
					<!-- image changed as part of WSTW-5899 -->
					<img id="footerLogoTwo" class="img-fluid pt-4 d-none d-md-block"
						src="assets/img/logos/top-100-agency-badge-2022-200x200.png" alt="Westwood Insurance logo"
						style="width: 60%;padding-left: 1rem;">
				</div>
				<div class="col-md-3">
					<div class="row">
						<div class="col-md-8 col-sm-6">
							<ul id="footerNav" class="nav flex-column pt-4">
								<li class="nav-item">
									<a class="nav-link pb-3 active" routerLink="/about-us">About</a>
								</li>
								<li class="nav-item">
									<a class="nav-link pb-3" routerLink="/products">Products</a>
								</li>
								<li class="nav-item">
									<a class="nav-link pb-3" routerLink="/current-customers">Customers</a>
								</li>
								<!-- <li class="nav-item">
											<a class="nav-link pb-3" routerLink="/current-customers/claims">Claims</a>
										</li> -->
								<li class="nav-item">
									<a class="nav-link pb-3" routerLink="/partners">Partners</a>
								</li>
								<li class="nav-item">
									<a class="nav-link pb-3" routerLink="/news">News</a>
								</li>
								<li class="nav-item">
									<a class="nav-link pb-3" routerLink="/get-a-quote">Get A Quote</a>
								</li>
								<li class="nav-item">
									<a class="nav-link pb-3" routerLink="/site-map">Site Map</a>
								</li>
							</ul>
						</div>
						<div class="col-md-4 col-sm-6">
								<!-- commented 70 years logo as part of WSTW-6205 -->
							<!-- <img alt="Westwood Insurance logo" class="img-fluid row pt-5 pl-5 d-md-none" id="footerLogoOne"
								src="assets/img/logos/70-logo-silver-large-font-gradient.svg">  -->
							<img alt="Westwood Insurance logo" class="img-fluid pt-4 pl-5 row  d-md-none"
								id="footerLogoTwoMobile" src="assets/img/logos/top-100-agency-badge-2022-200x200.png">
						</div>
					</div>
	
				</div>
				<div class="col-md-3 pt-4">
					<span class="text-uppercase text-white d-block pt-2"><a routerLink="/contact-us">Contact Us</a></span>
					<hr>
					<div class="row mb-2">
						<div class="col-2">
							<i class="fas fa-mobile-alt"></i>
						</div>
						<div class="col-10 pl-0">
							Current Customers
							<br>
							<a href="tel:18006765066" class="telNum">800.676.5066</a>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-2">
							<i class="fas fa-mobile-alt"></i>
						</div>
						<div class="col-10 pl-0">
							New Customers
							<br>
							<a href="tel:18885436179" class="telNum">888.543.6179</a>
						</div>
					</div>
	
	
					<div class="row mb-2">
						<div class="col-2">
							<i class="fas fa-envelope"></i>
						</div>
						<div class="col-10 pl-0">
							Email Us<br>
							<a href="mailto:Contactus@Westwoodins.com" class="emailUs">contactus@westwoodins.com</a>
						</div>
					</div>
					<div class="row mb-2" *ngIf="false">
						<div class="col-2">
							<i class="far fa-file-alt"></i>
						</div>
						<div class="col-10 pl-0">
							Careers at QBE<br>
							<a href="https://qbe.wd3.myworkdayjobs.com/QBE-Careers" target="_blank" class="telNum">Visit
								now</a>
						</div>
					</div>
				</div>
	
				<div class="col-md-3 pt-4 pl-4">
					<span class="text-uppercase text-white d-block pt-2">Connect with us</span>
					<hr>
					<div class="row">
						<div class="col-5  col-md-6 ">
							<div class="row border-color  ml-0 	shadow">
								<a href="https://www.facebook.com/WestwoodInsuranceAgency/" class="social "
									target="_blank"><i class="fab fa-facebook-f"></i></a>
							</div>
	
						</div>
						<div class="col-5  col-md-6 ">
							<div class="row border-color ml-1 shadow">
								<a href="https://www.linkedin.com/company/westwood-insurance-agency/" class="social"
									target="_blank"><i class="fab fa-linkedin-in"></i></a>
							</div>
	
						</div>
					</div>
	
				</div>
			</div>
			<div class="row py-2">
				<div class="col">
					<hr>
				</div>
			</div>
			<div id="copyrightCon" class="row">
				<div class="col">
					<p class="text-center">
						Licensed in California as Westwood Insurance Agency | Woodland Hills, CA | CA License #0401583
						<br>&copy; Westwood Insurance Agency. All Rights Reserved. <a href="https://baldwinriskpartners.com/terms-of-use/" target="_blank">Terms of Use</a> / <a
							href="https://baldwinriskpartners.com/privacy-policy/" target="_blank" >Privacy
							Policy</a>
					</p>
				</div>
			</div>
		</div>
	</section>
	
	<!-- // F O O T E R  -->
	
	<section id="alrt-extra-div">
		<div class="container">
			<div class="row"></div>
		</div>
	</section>
	